module.exports = __webpack_public_path__ + "static/media/chevron-up.f681d094.svg";